import { render, staticRenderFns } from "./file-new.vue?vue&type=template&id=8acfb5fa&"
import script from "./file-new.vue?vue&type=script&lang=js&"
export * from "./file-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports